var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66652 0.393777C1.31505 0.0423053 0.745203 0.0423049 0.393731 0.393777C0.042259 0.745249 0.042259 1.3151 0.393731 1.66657L2.72718 4.00002L0.393731 6.33347C0.042259 6.68495 0.042259 7.25479 0.393731 7.60627C0.745203 7.95774 1.31505 7.95774 1.66652 7.60627L3.99998 5.27281L6.33343 7.60627C6.6849 7.95774 7.25475 7.95774 7.60622 7.60627C7.95769 7.25479 7.95769 6.68495 7.60622 6.33347L5.27277 4.00002L7.60622 1.66657C7.95769 1.3151 7.95769 0.745249 7.60622 0.393777C7.25475 0.0423049 6.6849 0.0423046 6.33343 0.393777L3.99998 2.72723L1.66652 0.393777Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2585b4d7269a0c176cd4184ceb101093.svg";
export { ForwardRef as ReactComponent };